import { FunctionComponent, useEffect, useState } from 'react'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import { useOnboardContext } from 'modules/onboarding/context'

import {
  Container,
  Header,
  Action,
  Button,
  Main,
  Typography,
  Refresh,
  Error,
  WaveVariantE,
} from './styles'

import { SingleInputBoxes } from 'shared/components/InputBox/SingleInputBoxes'
import { steps } from 'modules/onboarding'

type TProps = {
  setSelectedStep?(step: number): void
}

const userRepository = new UserRepository()

const SMS: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const {
    state: { telefone },
  } = useOnboardContext()

  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleClearInput = () => {
    const inputs = document.querySelectorAll('input')
    inputs.forEach(i => {
      i.value = ''
    })
  }

  const onSubmitHandle = async (e: React.FormEvent) => {
    e.preventDefault()
    if (pin.length < 6) {
      return
    }
    try {
      const res = await userRepository.verifyPin({ code: pin, phone: telefone })
      if (!res.valid) {
        setError(true)
        setErrorMessage('PIN inválido')
        handleClearInput()
        return
      }
      setSelectedStep(steps.DefinicaoSenha)
    } catch (err) {
      setError(true)
      setErrorMessage(err?.message)
      handleClearInput()
    }
  }

  const sendPin = async () => {
    setLoading(true)
    try {
      await userRepository.sendPin({ phone: telefone })
      setErrorMessage('')
      setError(false)
    } catch (err) {
      setErrorMessage(err?.message)
      setError(true)
    }
    setLoading(false)
  }

  useEffect(() => {
    sendPin()
  }, [telefone])

  return (
    <Container>
      <Header />
      <Main>
        <Typography variant="p1" fontWeight="semibold">
          Agora digite o PIN enviado no celular cadastrado via SMS.
        </Typography>
        <form autoComplete="off" id="pinForm" onSubmit={onSubmitHandle}>
          <SingleInputBoxes
            type="text"
            amount={6}
            onChangeValueInputBox={setPin}
          />
        </form>
        {error && <Error>{errorMessage}</Error>}
        {error && !loading && (
          <Button
            disabled={loading}
            variant="text"
            type="button"
            onClick={sendPin}
          >
            <Refresh />
            Reenviar PIN via SMS
          </Button>
        )}
        {loading && <WaveVariantE />}
      </Main>
      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.Pin)}
        >
          Voltar
        </Button>
        <Button
          disabled={pin.length < 6}
          type="submit"
          variant="contained"
          size="lg"
          form="pinForm"
        >
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default SMS
